import theme from '@app/ui/theme'
import styled from 'styled-components'

export const ContentHeading = styled.h2`
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 23px;
  font-weight: 460;
  letter-spacing: 0.4px;
  color: #242c2b;
`

export const ContentSeparator = styled.div`
  margin-top: 14px;
  margin-bottom: 25px;
  height: 1px;
  background-color: ${theme.colors.light};
`

// The row these fields are laid out in moved to the shared form fields when
// the slope table form started using it too. Still exported from here for the
// places that already import it under this name.
export { FieldRow as CourseOptionView } from '../FormFields/styled'
